export enum EstadoSolicitudCrediticia {
  Pendiente = 0,
  Aprobada = 1,
  Rechazada = 2
}
